import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import Library from "@/site/pages/Library.vue";
import helpers from "@/site/plugins/helpers";

const messages = (window as any).translations;

const i18n = createI18n({
    legacy: false,
    locale: document.documentElement.lang,
    fallbackLocale: 'en',
    messages,
});

createApp(Library)
    .use(i18n)
    .use(helpers)
    .mount('#library');
